import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Base64
import { decode as base64Decode } from 'js-base64';

// Components
import FullScreenLoader from '../../../layout/components/FullScreenLoader/FullScreenLoader';

// Events
import forceAuthorizationEvent from '../../events/forceAuthorization.event.auth';

// Loading
import loadingRoute from '../../../layout/pages/LoadingPage/route';

// PerformAuth
import performAuthRoute from '../../pages/PerformAuthPage/route';

const AuthCallbackContainer = ({ code, state, window: windowProp = window }) => {
  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      try {
        const { code_verifier, redirectTo } = JSON.parse(base64Decode(state));
        const path = performAuthRoute({ code, code_verifier });
        if (!redirectTo) {
          history.replace(path);
          return;
        }
        windowProp.location.href = `${redirectTo}${path}`;
      } catch (error) {
        history.replace(loadingRoute());
        forceAuthorizationEvent.publish();
      }
    };

    init();
  }, [code, state, history, windowProp]);

  return <FullScreenLoader />;
};

AuthCallbackContainer.propTypes = {
  code: PropTypes.string,
  state: PropTypes.string,
  window: PropTypes.object,
};

export default AuthCallbackContainer;
